import * as React from 'react';
import { connect } from 'react-redux';
import { IAuthState } from '../../Auth/store/types';
import { IReduxState } from '../../../reduxTypes';
import SidebarContainer from 'src/modules/Routing/Sidebar/SidebarContainer';
import { RoutesModules } from 'src/modules/Routing/types';
import './account.css';

export interface IAccountProps {
    auth: IAuthState;
}

// Read-only account summary — the settings home after in-app password management was
// retired in favor of the Cognito hosted UI (login, MFA, and password reset all run
// there). Layout mirrors the Upload Cases card. Resets are self-service via the
// hosted-UI "Forgot password?" on the sign-in page.
export class Account extends React.Component<IAccountProps> {
    public render() {
        const { username, agencyCode, userType } = this.props.auth;
        return (
            <div className="account">
                <div className="account-content white-background">
                    <h3 className="title">Account</h3>
                    <dl className="subFont">
                        <dt>Email</dt>
                        <dd>{username || '—'}</dd>
                        <dt>Agency</dt>
                        <dd>{agencyCode || '—'}</dd>
                        <dt>Role</dt>
                        <dd>{userType || '—'}</dd>
                    </dl>
                    <p className="reset-note subFont">
                        To change your password, sign out and use <strong>“Forgot password?”</strong> on
                        the sign-in screen.
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState) => ({
    auth: state.auth
});

export default SidebarContainer(RoutesModules.SETTINGS)(connect(mapStateToProps)(Account));
